import { Fragment, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { getRequest } from '../../app/request';
import { usePopupContext } from '../Popup/PopupContext.js';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import OfferInfo from './OfferInfo';
import { OffersContainerStyled, OffersPageStyled } from './styled/OffersStyled';

const MANAGER_EMAIL = 'affiliers@jetvix.com';

function Offers() {
    const [offersList, setOffersList] = useState(null);
    const { catchPopup } = usePopupContext();
    const { getLangPath } = useLangContext();

    const getOffersList = useCallback(() => {
        getRequest(`/partner/offers/list`)
            .then((res) => {
                setOffersList(res);
            })
            .catch((e) => {
                catchPopup(e.response);
            });
    }, [catchPopup]);

    useEffect(() => {
        getOffersList();
    }, [getOffersList]);

    if (!offersList) {
        return null;
    }

    return (
        <OffersPageStyled>
            <div className="page-header">
                <span className="section-eyebrow">{getLangPath('offers.eyebrow')}</span>
                <h1 className="page-title">{getLangPath('offers.title')}</h1>
                <p className="page-desc">{getLangPath('offers.desc')}</p>
            </div>

            <OffersContainerStyled>
                {offersList.length === 0 ? (
                    <p className="offers-empty">
                        {getLangPath('offers.empty')}{' '}
                        <a href={`mailto:${MANAGER_EMAIL}`}>{MANAGER_EMAIL}</a>
                    </p>
                ) : (
                    _.sortBy(offersList, 'id').map((item) => (
                        <Fragment key={item.id}>
                            <OfferInfo offerInfo={item} getOffersList={getOffersList} />
                        </Fragment>
                    ))
                )}
            </OffersContainerStyled>
        </OffersPageStyled>
    );
}

export default Offers;
